import { theme } from 'styles/theme/hav-theme'

import { BoxStyled, CircularProgressStyled } from './styles'

interface Props {
  isRoute?: boolean
  size?: string
  color?: string
}
export const CircularProgress: React.FC<Props> = ({
  isRoute = false,
  size = '40px',
  color = theme.colors.primary.main,
}) => (
  <>
    <BoxStyled isroute={isRoute ? 1 : 0}>
      <CircularProgressStyled customcolor={color} size={size} />
    </BoxStyled>
  </>
)
